// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__371zM","buttons":"Footer_buttons__34Jdr"};